import { render, staticRenderFns } from "./Chart.vue?vue&type=template&id=524eb3ba&"
import script from "./Chart.vue?vue&type=script&lang=js&"
export * from "./Chart.vue?vue&type=script&lang=js&"
import style0 from "./Chart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../Users/atec/.config/yarn/global/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports